import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DownloadIcon from '@mui/icons-material/Download';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import Grid from '@mui/material/Grid';
import { useLocation, useSearchParams } from "react-router-dom";
import { store } from '../helpers/store';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { fetchInvoices, invoiceItemsSelector, setInvoiceLoading, setInvoiceSearchKeyDeliverylocationumber, setInvoiceSearchKeyFromdate, setInvoiceSearchKeySaletype, setInvoiceSearchKeyTodate, setInvoiceSearchKeyNumber, setInvoiceSearchKey, clearInvoiceFilters, fetchInvoice, clearInvoiceItems, clearSelectedInvoice } from "../slices/invoices.slice";
import DataGrid from 'react-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { pink } from '@mui/material/colors';
import SvgIcon from '@mui/material/SvgIcon';
import DehazeIcon from '@mui/icons-material/Dehaze';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
import moment from 'jalali-moment'
import Tooltip from '@mui/material/Tooltip';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import JalaliUtils from "@date-io/jalaali";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Modal from "@material-ui/core/Modal";
import { useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArgonBox from "../components/dashdata/ArgonBox";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import textEditor from '../components/dashdata/TextEditor';
import PrintIcon from '@mui/icons-material/Print';
import { getReportURL } from '../api';


export const zeroPad = (num, places) => String(num).padStart(places, '0');

const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};


export const Invoice = () => {
  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))

  const invoices = useSelector(x => x.invoices);
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  let navigate = useNavigate();


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    //color: theme.palette.text.secondary,
  }));
  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");

 let entityId = invoices.selectedInvoiceId;

const columns = [
  {
    name: 'ردیف',
    key: 'rowIndex',
    width: '5%',
  }, 
  {
    key: 'ItemCode',
    name: 'کد محصول',
    width: '10%',
    resizable: true,
    sortable: true,
    //editor : textEditor
    
  },
  {
    key: 'ItemName',
    name: 'عنوان محصول',
    width: '25%',
    resizable: true,
    sortable: true,
    //editor : textEditor,
    /*
    headerRenderer(props) {
      return ( "" );
    },
    formatter(props) {
      console.log(props.row);
          return  <TextField size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.ItemName}/>;
    }
    */
  },
  {
    key: 'UnitTitle',
    name: 'واحد',
    width: '5%',
    resizable: true,
    sortable: true,
    //editor : textEditor,
  },
  {
    key: 'Quantity_sh',
    name: 'تعداد',
    width: '5%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Fee_sh',
    name: 'فی',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Price_sh',
    name: 'کل',
    type: 'number',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Discount_sh',
    name: 'تخفیف',
    type: 'number',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'NetPrice_sh',
    name: 'خالص',
    type: 'number',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Description',
    name: 'توضیحات',
    width: '20%',
    resizable: true,
    sortable: true
  }
];


   useEffect(() => {

      dispatch(clearSelectedInvoice());
      dispatch(fetchInvoice({saleDocId: entityId, saleDocType : 2 , authUser}));

   }, []);


   const handleChange = (e , changingItemType, props , value) => {
  
    switch(changingItemType) {
      case 'unitTitle':
        // code block
        //console.log(props.row.Number);
        break;
      case 'number':
        console.log("Value is "+ value);
        //dispatch(fetchInvoice({saleDocId: props.row.ID, saleDocType : 2 , authUser}));

        // code block
        break;
      default:
        // code block
    }
  
  }
  
  function rowKeyGetter(row) {
    return row.ID;
  }

  
  function EmptyRowsRenderer() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {invoices.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  
  
   let dataSource  = [];
   //let dynamicHeight = 0; 
   console.log(invoices.selectedInvoice);
   if(invoices.selectedInvoice != undefined && invoices.selectedInvoice.Items !== undefined && invoices.selectedInvoice.Items !== null && invoices.selectedInvoice.Items.length > 0)
   {
       dataSource = invoices.selectedInvoice.Items.map((item, i) => ({...item, rowIndex : i+1}));
       //dynamicHeight = Math.min(invoices.selectedInvoice.items.length * 6 + 10, 75) + 'vh';
   }


   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const onBackClicked = (e) =>{

  navigate('/invoices');

}
const onPrintClicked = (e) =>{

  console.log(process.env.REACT_APP_REPORT_URL);
  var baseAdsress = getReportURL();//process.env.REACT_APP_REPORT_URL;//'http://80.210.21.25:81';//http://151.244.74.226/
  console.log("baseAdsress",baseAdsress);
  var reportName = 'FInvoice';
  var up = authUser.username+'$'+encodeURIComponent(authUser.password);
  var ul = baseAdsress+"/Home/PDFReportPage2?reportname="+reportName+"&SelectedValue="+invoices.selectedInvoiceId+"&hash="+up
  console.log("URL id");
  console.log(ul);
  const link = document.createElement('a');
  link.setAttribute('target', '_blank');
  link.href = ul;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
const onPrintLClicked = (e) =>{

  console.log(process.env.REACT_APP_REPORT_URL);
  var baseAdsress = getReportURL();//process.env.REACT_APP_REPORT_URL;//'http://80.210.21.25:81'; //http://151.244.74.226/
  var reportName = 'FInvoiceA5L';
  var up = authUser.username+'$'+encodeURIComponent(authUser.password);
  var ul = baseAdsress+"/Home/PDFReportPage2?reportname="+reportName+"&SelectedValue="+invoices.selectedInvoiceId+"&hash="+up
  console.log("URL id");
  console.log(ul);
  const link = document.createElement('a');
  link.setAttribute('target', '_blank');
  link.href = ul;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
const getMimeType = (extension) => {
  const mimeTypes = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    rar: "application/vnd.rar",
    zip: "application/zip",
    txt: "text/plain",
    json: "application/json",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // اکسل جدید
    xls: "application/vnd.ms-excel", // اکسل قدیمی
    default: "application/octet-stream", // پیش‌فرض
  };
  return mimeTypes[extension.toLowerCase()] || mimeTypes.default;
};
const onDownloadClicked = (e) => {
  try {
   // ایجاد Blob از داده Base64
   const byteCharacters = atob(invoices.selectedInvoice.Attachments[0].File); // Decode base64 string to binary string
   const byteArrays = [];

   // تبدیل رشته باینری به آرایه بایت
   for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
     const slice = byteCharacters.slice(offset, offset + 1024);
     const byteNumbers = new Array(slice.length);
     for (let i = 0; i < slice.length; i++) {
       byteNumbers[i] = slice.charCodeAt(i);
     }
     const byteArray = new Uint8Array(byteNumbers);
     byteArrays.push(byteArray);
   }

   // ساخت یک Blob از آرایه بایت‌ها
   const blob = new Blob(byteArrays, { type: 'application/octet-stream' });

   // ایجاد یک لینک دانلود
   const link = document.createElement('a');
   link.href = URL.createObjectURL(blob);
   link.download = `${invoices.selectedInvoice.Attachments[0].Title.replaceAll(" ","_")}.${invoices.selectedInvoice.Attachments[0].FileType}`; // نام فایل برای دانلود
   document.body.appendChild(link); // اضافه کردن لینک به صفحه
   link.click(); // فعال کردن لینک برای دانلود
   document.body.removeChild(link); // حذف لینک پس از دانلود


   // link.download = `${invoices.selectedInvoice.Attachments[0].Title.replaceAll(" ","_")}.${invoices.selectedInvoice.Attachments[0].FileType}`;

  } catch (error) {
    console.error("Error downloading the file:", error);
  }
}

  return (
    <>

<ThemeProvider theme={mdTheme}>

  <Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>
                       
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
           
                 <Typography sx={{ width: '60%', flexShrink: 0 }}>
                 فاکتور فروش &nbsp;#{invoices.selectedInvoice.Number} &nbsp; {invoices.selectedInvoice.CustomerDLTitle} &nbsp; {invoices.selectedInvoice.CustomerDLCode}
          </Typography>
                     
                       
                </AccordionSummary>
                <AccordionDetails>

    <Grid container spacing={2}>
        <Grid item xs={2} md={1} lg={1} >

        <Tooltip arrow followCursor title="برگشت به فهرست">
        <IconButton onClick={onBackClicked}>
                  <ArrowForwardIcon sx={{ color: '#000000' }}/>
                </IconButton>
              </Tooltip>
              
        </Grid>
        <Grid item xs={1} md={1} lg={1} >
        <Tooltip arrow followCursor title="پرینت فاکتور عمودی">
        <IconButton onClick={onPrintClicked}>
                            <PrintIcon sx={{ color: '#000000' }}/>
                          </IconButton>
              </Tooltip>
                         
        </Grid>
        <Grid item xs={1} md={1} lg={1} >
        <Tooltip arrow followCursor title="پرینت فاکتور A5 افقی">
          <IconButton onClick={onPrintLClicked}>
                            <PrintIcon sx={{ color: '#000000' }}/>
                          </IconButton>
        </Tooltip>       

        &nbsp;&nbsp;
        {invoices.selectedInvoice.Attachments !== undefined && invoices.selectedInvoice.Attachments !== null && invoices.selectedInvoice.Attachments.length > 0 ?  
          
          <Tooltip arrow followCursor title="دانلود پیوست">
          <IconButton onClick={onDownloadClicked}>
            <DownloadIcon sx={{ color: '#000000' }}/>
          </IconButton>
        </Tooltip>       
         
           : ""}

        </Grid>
      
        <Grid item xs={9} md={4} lg={2}>
          <Item><span style={{ fontWeight : 'bold' }}>تاریخ ‌ : </span> &nbsp;{invoices.selectedInvoice.Date}</Item>
        </Grid>
        <Grid item xs={9} md={4} lg={2}>
          <Item><span style={{ fontWeight : 'bold' }}>محل تحویل: ‌</span> ‌&nbsp;{invoices.selectedInvoice.DeliveryLocationTitle}</Item>
        </Grid>
        <Grid item xs={9} md={4} lg={2}>
          <Item><span style={{ fontWeight : 'bold' }}>نوع فروش ‌: </span>{invoices.selectedInvoice.SaleTypeTitle}</Item>
        </Grid>
        <Grid item xs={9} md={4} lg={3}>
          <Item><span style={{ fontWeight : 'bold' }}>ایجاد کننده:‌ </span>&nbsp;{invoices.selectedInvoice.Creator}</Item>
        </Grid>
       
        </Grid>
   
                </AccordionDetails>
          </Accordion>
             </Grid>
     </Grid>
     </Box>

<DataGrid 
    renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
    direction="rtl" 
    columns={columns} 
    rows={dataSource} 
    rowKeyGetter={rowKeyGetter}
    //style={{height : dynamicHeight}}
    />

<Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>
                       
                        <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-footer"
                >
           
                 <Typography sx={{ width: '33%', flexShrink: 0 }}>
                 مبالغ 
          </Typography>
                     
                       
                </AccordionSummary>
                <AccordionDetails>
    <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <Item ><span style={{ fontWeight : 'bold' }}>شرح:‌</span> &nbsp;{invoices.selectedInvoice.Description} &nbsp;<br/>&nbsp; {invoices.selectedInvoice.DocDescription}</Item>
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <Item style={{ color : '#3949AB' }}><span style={{ fontWeight : 'bold' , color : '#3949AB' }}> کل: ‌</span> ‌&nbsp;{invoices.selectedInvoice.Price_sh}</Item>
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <Item style={{ color : '#E53935' }}><span style={{ fontWeight : 'bold' , color : '#E53935' }}> تخفیف: ‌</span>{invoices.selectedInvoice.Discount_sh}</Item>
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <Item style={{ color : '#43A047' }}><span style={{ fontWeight : 'bold' , color : '#43A047' }}> خالص :‌</span>&nbsp;{invoices.selectedInvoice.NetPrice_sh}</Item>
        </Grid>
   
        <Grid item xs={12} md={12} lg={12}>
        {invoices.loading ? "" :
          (invoices.selectedInvoice.Settleable_sh != null && parseFloat(invoices.selectedInvoice.Settleable_sh.replaceAll(',','')) > 0 ?
          <Item><span style={{ fontWeight : 'bold', color: '#D32F2F'  }}> مانده فاکتور : &nbsp;{invoices.selectedInvoice.Settleable_sh}</span>
          &nbsp;  <Button sx={boxSX}  variant="contained">تسویه فاکتور</Button>
          </Item>
          :   
          <Item><CheckBoxIcon sx={{ color: '#4CAF50' }} /><span style={{ fontWeight : 'bold'}}> تسویه شده</span></Item>
          )
          }
        </Grid>
      </Grid>
   </AccordionDetails>
          </Accordion>
             </Grid>
     </Grid>
     </Box>

    {invoices.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    </ThemeProvider>
    </>
  );
}

export default Invoice;